import { WorkflowStepLabel } from '../common/enum/WorkflowStepLabel';

export default function selectOnlyOneUser(workflowStepId: number): boolean {
  return (
    workflowStepId === WorkflowStepLabel.FinalApprover ||
    workflowStepId === WorkflowStepLabel.ExternalApprover
  );
}
